























































































import { Component, Vue } from 'vue-property-decorator';

@Component({})
export default class BankPos extends Vue {
  bankPosAccounts: any[] = [];
  headers: any[] = [];
  breadcrumbsItems: any[] = [];
  page: number = 1;
  pageCount: number = 0;
  isOpenModal: boolean = false;
  editItem: any = {};
  currencies: string[] = ['TRY', 'USD', 'EUR', 'RUB', 'KZT', 'BYN', 'UZS', 'GBP'];

  get loading() {
    return this.$store.state.bankPosAccount.loading;
  }

  get availableBanks(): string[] {
    const names = this.bankPosAccounts.map((item: any) => item.bankName);
    return [...new Set(names)];
  }

  async created() {
    this.headers = [
      { text: 'Banka Adı', align: 'start', value: 'bankName' },
      { text: 'Para Birimi', value: 'currencyId' },
      { text: 'Durum', value: 'isActive' },
      { text: 'İşlemler', value: 'actions', sortable: false },
    ];

    this.breadcrumbsItems = [
      { text: 'Ana Sayfa', disabled: false, href: '/#/main/home' },
      { text: 'Finans', disabled: true },
      { text: 'Banka Pos', disabled: true },
    ];

    await this.getBankPosAccounts();
  }

  async getBankPosAccounts() {
    await this.$store.dispatch({
      type: 'bankPosAccount/getAllBankPosAccounts',
    });
    this.bankPosAccounts = this.$store.state.bankPosAccount.list;
  }

  openEditModal(item: any) {
    this.editItem = { ...item };
    this.isOpenModal = true;
  }

  closeModal() {
    this.isOpenModal = false;
    this.editItem = {};
  }

  async saveEdit() {
    await this.$store.dispatch({
      type: 'bankPosAccount/editBankPosAccount',
      data: {
        id: this.editItem.id,
        bankName: this.editItem.bankName,
        currencyId: this.editItem.currencyId,
        isActive: this.editItem.isActive,
      },
    });
    this.closeModal();
    await this.getBankPosAccounts();
  }
}
